import { KIM_API_KEY } from "../../tools/helper";

import { Fragment, useState } from "react";
import { JSX } from "react";

import { ConfigurationChildEventUnion } from "@plansoft-configuration-renderer/events";
import {
  useConfigurationApi,
  useConfigurationEvent,
  useCsAttributeById,
  useCsConfigurationApi,
  useSessionId,
} from "@plansoft-configuration-renderer/framework";

import { useCadStatus } from "./customContext/CadStatusContext";

interface IFormattedAssemblyDataInstance {
  [key: string]: unknown;
  product: {
    [key: string]: unknown;
    parameters: {
      question: string;
      value?: string;
    }[];
  };
}
interface IFormattedAssemblyDataInstances {
  instance: IFormattedAssemblyDataInstance;
}
interface IFormattedAssemblyData {
  instances: IFormattedAssemblyDataInstances[];
}

export function ConfigurationStateSpy(): JSX.Element {
  const sessionId = useSessionId();
  const configurationApi = useConfigurationApi();

  const { setIsCadLoading } = useCadStatus();
  const attProductView = useCsAttributeById("XAS_PRODUCT_VIEW");
  const { invokeUserDefinedFunction } = useCsConfigurationApi();
  const cadTimestamp =
    attProductView?.configurations?.[0]?.properties?.CAD_TIMESTAMP?.value;
  const timestamp = cadTimestamp;
  const [timestampOld, setTimestampOld] = useState<number>();

  const handleCadBoundingBoxInformation = async (): Promise<void> => {
    let cadData;
    setIsCadLoading(true);
    try {
      let assemblyData = await configurationApi.getCadClickAssembly({
        id: sessionId,
      });

      const formattedAssemblyData: IFormattedAssemblyData = {
        instances: [],
      };

      if (assemblyData.assembly && assemblyData.assembly.instances) {
        // @ts-expect-error: API result and type declaration is broken, here we force it into a new structure.
        formattedAssemblyData.instances = assemblyData.assembly.instances.map(
          (data) => {
            const instanceData = { ...data.instance };
            return { instance: instanceData };
          },
        );
      }

      const cadResponse = await fetch(
        import.meta.env.VITE_APP_KIM_ENDPOINT + "v1/assembly/bounding-box",
        {
          method: "POST",
          headers: {
            "x-api-key": KIM_API_KEY,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formattedAssemblyData),
        },
      );
      cadData = await cadResponse.json();

      const inputObj = {
        width: (cadData[0] - cadData[3]) * -1,
        depth: (cadData[1] - cadData[4]) * -1,
        height: (cadData[2] - cadData[5]) * -1,
      };

      const outputUpdateCADBoundingBox = await invokeUserDefinedFunction({
        name: "updateCADBoundingBox",
        input: JSON.stringify(inputObj),
        path: "/XAS_PRODUCT_VIEW/0",
      });

      console.log(`invokeUserDefinedFunction "updateCADBoundingBox":`, {
        inputObj,
        outputUpdateCADBoundingBox,
      });
    } catch (error) {
      console.warn(error);
    }
    setIsCadLoading(false);
  };

  const onConfigurationEvent = (event: ConfigurationChildEventUnion): void => {
    const eventAttributes = event.configuration.objects?.[0].attributes;
    const atts_XAS_PRODUCT_VIEW = eventAttributes?.find(
      (att) => att.id === "XAS_PRODUCT_VIEW",
    );
    const properties = atts_XAS_PRODUCT_VIEW?.configurations?.[0].properties;
    const newTimestamp = properties?.CAD_TIMESTAMP?.value;

    if (newTimestamp !== null && newTimestamp !== timestampOld) {
      setTimestampOld(timestamp);
      handleCadBoundingBoxInformation();
    }
  };

  useConfigurationEvent({
    onConfigurationEvent: onConfigurationEvent,
  });

  return <Fragment />;
}
